"use client"

import type React from "react"
import AuthModal from "./AuthModal"
import WelcomeBackModal from "./WelcomeBackModal"
import BrokerProfileRequiredModal from "./BrokerProfileRequiredModal"
import PriceConversionModal from "./PriceConversionModal"
import PropertyFilterModal from "./PropertyModalFilter"
import CompaniesModal from "./CompaniesModal"
import SettingsModal from "./SettingsModal"
import { useNavigation } from "../../hooks/useNavigation"

export const ModalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const {
    openAuthModal,
    openWelcomeBackModal,
    openBrokerProfileRequiredModal,
    openConvertModal,
    openFilterModal,
    openRealEstateModal,
    openSettingsModal,
    handleAuthModalClose,
    handleWelcomeBackModalClose,
    handleBrokerProfileRequiredModalClose,
    handleConvertModalClose,
    handleFilterModalClose,
    handleCloseRealEstateModal,
    handleCloseSettingsModal,
    handleAuthModalOpen,
  } = useNavigation()

  return (
    <>
      {children}

      {/* Modales globales */}
      {openAuthModal && (
        <AuthModal
          open={openAuthModal}
          onClose={handleAuthModalClose}
          sx={{
            zIndex: 1400,
          }}
        />
      )}

      {openWelcomeBackModal && (
        <WelcomeBackModal
          open={openWelcomeBackModal}
          onClose={handleWelcomeBackModalClose}
          onSignIn={handleAuthModalOpen}
          sx={{
            zIndex: 1400,
          }}
        />
      )}

      <BrokerProfileRequiredModal
        open={openBrokerProfileRequiredModal}
        onClose={handleBrokerProfileRequiredModalClose}
        sx={{
          zIndex: 1400,
        }}
      />

      {openConvertModal && (
        <PriceConversionModal
          open={openConvertModal}
          onClose={handleConvertModalClose}
          sx={{
            zIndex: 1400,
          }}
        />
      )}

      {openFilterModal && (
        <PropertyFilterModal
          open={openFilterModal}
          onClose={handleFilterModalClose}
          sx={{
            zIndex: 1400,
          }}
        />
      )}

      <CompaniesModal
        open={openRealEstateModal}
        onClose={handleCloseRealEstateModal}
        sx={{
          zIndex: 1400,
        }}
      />

      <SettingsModal
        open={openSettingsModal}
        onClose={handleCloseSettingsModal}
        sx={{
          zIndex: 1400,
        }}
      />
    </>
  )
}
